import React from "react";
import moment from "moment";
import { ISurveyQuestion } from "../../../models/survey/survey-question.model";
import { surveyValueInput } from "./survey-answer-question-card.module.scss";

export interface ISurveyAnswerInputDateProps {
    question: ISurveyQuestion;
    value: string | null;
    onChange: (value: string) => void;
}

const SurveyAnswerInputDate: React.FC<ISurveyAnswerInputDateProps> = ({
    question,
    value,
    onChange,
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
    };

    // Konwersja wartości na format YYYY-MM-DD dla input type="date"
    const getDateValue = (): string => {
        if (!value) return "";
        
        // Jeśli to unix timestamp
        if (typeof value === "number") {
            return moment(value * 1000).format("YYYY-MM-DD");
        }
        
        // Jeśli to string w formacie DD.MM.YYYY
        if (typeof value === "string") {
            const momentDate = moment(value, "DD.MM.YYYY", true);
            if (momentDate.isValid()) {
                return momentDate.format("YYYY-MM-DD");
            }
            // Jeśli to już YYYY-MM-DD
            if (moment(value, "YYYY-MM-DD", true).isValid()) {
                return value;
            }
        }
        
        return "";
    };

    return (
        <input
            type="date"
            className={surveyValueInput}
            value={getDateValue()}
            onChange={handleChange}
            aria-label={question.title}
        />
    );
};

export default SurveyAnswerInputDate;
